import { BACKEND_API_URL } from '@/lib/public-api-url';
import type { MediaAuthorsApiAuthorPageResponse } from './media-authors-api.types';
import type { MediaAuthorArticlesPage } from '../types';
import {
  mapMediaAuthorArticlesPage,
  MEDIA_AUTHORS_DEFAULT_ARTICLES_LIMIT,
} from '../utils/map-media-author.util';

type FetchMediaAuthorArticlesInput = {
  readonly username: string;
  readonly page: number;
  readonly limit?: number;
};

/**
 * Client-side fetch for author articles pagination (infinite scroll).
 */
export async function fetchMediaAuthorArticlesPage(
  input: FetchMediaAuthorArticlesInput,
): Promise<MediaAuthorArticlesPage> {
  const limit = input.limit && input.limit > 0 ? input.limit : MEDIA_AUTHORS_DEFAULT_ARTICLES_LIMIT;
  const query = new URLSearchParams({
    page: String(input.page),
    limit: String(limit),
  });
  const url = new URL(
    `/api/v1/media/authors/${encodeURIComponent(input.username)}?${query.toString()}`,
    BACKEND_API_URL,
  ).toString();
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load author articles: ${response.status}`);
  }
  const data = (await response.json()) as MediaAuthorsApiAuthorPageResponse;
  return mapMediaAuthorArticlesPage(data, limit);
}
